import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  useCallback,
  memo,
} from "react";
import { Link } from "react-router-dom";
import moment from "moment";

// MUI Components (필요시에만 사용)
import {MuiSelects} from "../../../../components/MUI/console/Select"

// Project Components
import { AppContext } from "../../../../components/AppProvider";
import { _API, _CK, _U } from "../../../../modules/utils";
import Paging from '../../../../components/pagination/pagination';
import Layout, { Wrapper,HiddenWrapper } from "../Layouts/Layout";
import useStore from "../../../../modules/utils/store";
import BaseModal from "../../../../components/UI/Modal/BaseModal";
import EventDetailContent from "../../../../components/UI/Modal/EventDetailContent";

import PolygonImg from "../../../../resources/preReg/images/icon/polygon.svg";

// Swiper Components
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

// Swiper Styles
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";
import "swiper/components/scrollbar/scrollbar.scss";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

// ─── 모듈 레벨 유틸 ─────────────────────────────────────────────────────────
const computeDurationText = (startDate, endDate) => {
  try {
    const start = moment(startDate);
    const end = moment(endDate);
    if (!start.isValid() || !end.isValid()) return '';
    const duration = moment.duration(end.diff(start));
    const totalHours = Math.floor(duration.asHours());
    const minutes = duration.minutes();
    if (totalHours < 0 || (totalHours === 0 && minutes < 0)) return '';
    if (totalHours < 24) {
      return ` (${String(totalHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')})`;
    }
    return ` (${Math.ceil(totalHours / 24)}일)`;
  } catch {
    return '';
  }
};

// ─── 데스크탑 테이블 헤더 (정적이므로 memo로 분리) ────────────────────────
const DesktopTableHeader = memo(({ siteInfo }) => (
  <div className="self-stretch h-12 p-4 rounded-tl-lg border-b border-zinc-200 inline-flex justify-start items-center border-solid">
    <div className="flex-1 flex justify-start items-center">
      <div className="flex-1 text-center justify-center text-zinc-400 text-xs font-normal font-['Noto_Sans_KR'] leading-none">심포지엄</div>
    </div>
    <div className="w-24 h-12 px-4 inline-flex justify-center items-center">
      <div className="flex-1 text-center justify-center text-zinc-400 text-xs font-normal font-['Noto_Sans_KR'] leading-none">참가세션</div>
    </div>
    <div className="w-28 h-12 px-4 inline-flex justify-center items-center">
      <div className="flex-1 text-center justify-center text-zinc-400 text-xs font-normal font-['Noto_Sans_KR'] leading-none">최초참가시간</div>
    </div>
    <div className="w-28 h-12 inline-flex justify-center items-center gap-x-1">
      <div className="text-center justify-center text-zinc-400 text-xs font-normal font-['Noto_Sans_KR'] leading-none">총시청시간</div>
      <div
        data-rounded="Full"
        data-size="Small"
        data-style="Ghost"
        className="size-7 rounded-full flex justify-center items-center hover:bg-[#efeff6] transition-colors cursor-pointer group relative"
      >
        <div data-svg-wrapper className="relative">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2879_9063)">
              <path fillRule="evenodd" clipRule="evenodd" d="M7.99984 1.99996C4.68613 1.99996 1.99984 4.68625 1.99984 7.99996C1.99984 11.3137 4.68613 14 7.99984 14C11.3135 14 13.9998 11.3137 13.9998 7.99996C13.9998 4.68625 11.3135 1.99996 7.99984 1.99996ZM0.666504 7.99996C0.666504 3.94987 3.94975 0.666626 7.99984 0.666626C12.0499 0.666626 15.3332 3.94987 15.3332 7.99996C15.3332 12.05 12.0499 15.3333 7.99984 15.3333C3.94975 15.3333 0.666504 12.05 0.666504 7.99996ZM8.17192 5.3495C7.86157 5.29627 7.5424 5.35459 7.27093 5.51414C6.99946 5.67368 6.79322 5.92415 6.68873 6.22119C6.56655 6.56851 6.18593 6.75103 5.83861 6.62885C5.49128 6.50667 5.30877 6.12606 5.43095 5.77873C5.63993 5.18466 6.05242 4.68371 6.59535 4.36463C7.13829 4.04554 7.77663 3.9289 8.39733 4.03536C9.01802 4.14183 9.58101 4.46453 9.98657 4.94631C10.3921 5.42799 10.614 6.03761 10.6132 6.66723C10.6129 7.68747 9.85646 8.36122 9.3163 8.72133C9.02588 8.91494 8.74021 9.0573 8.52976 9.15083C8.42359 9.19802 8.33419 9.23383 8.26977 9.25837C8.23751 9.27066 8.21135 9.28019 8.1923 9.28696L8.16915 9.29506L8.16178 9.29758L8.15918 9.29846L8.15816 9.2988C8.15796 9.29887 8.15732 9.29908 7.9465 8.66663L8.15732 9.29908C7.80803 9.41551 7.43048 9.22674 7.31405 8.87744C7.19766 8.52826 7.38626 8.15085 7.73534 8.03429L7.74562 8.03067C7.75588 8.02702 7.77269 8.02093 7.79511 8.01238C7.84006 7.99526 7.90691 7.96856 7.98824 7.93242C8.1528 7.85928 8.36712 7.75164 8.5767 7.61193C9.03644 7.30544 9.27984 6.97938 9.27984 6.66663L9.27984 6.66563C9.28031 6.35075 9.16932 6.04587 8.96654 5.80498C8.76376 5.56409 8.48226 5.40274 8.17192 5.3495ZM7.33317 11.3333C7.33317 10.9651 7.63165 10.6666 7.99984 10.6666H8.0065C8.37469 10.6666 8.67317 10.9651 8.67317 11.3333C8.67317 11.7015 8.37469 12 8.0065 12H7.99984C7.63165 12 7.33317 11.7015 7.33317 11.3333Z" fill="#71717A"/>
            </g>
            <defs>
              <clipPath id="clip0_2879_9063">
                <rect width="16" height="16" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </div>
        {/* 호버 툴팁 */}
        <div className="absolute bottom-[116%] left-1/2 transform -translate-x-1/2 mb-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none z-20">
          <div className="px-3 py-1.5 bg-[#efeff6] rounded-md shadow-md whitespace-nowrap">
            <div className="text-zinc-500 text-xs font-normal font-['Noto_Sans_KR'] leading-tight">
              총 시청 시간은 중복 시청 시간을 제외한<br/>순수 시청 시간입니다.
            </div>
          </div>
          <div className="absolute top-[78%] left-1/2 transform -translate-x-1/2">
            <img src={PolygonImg} alt="polygon" className="w-[17px] h-[17px]" />
          </div>
        </div>
      </div>
    </div>
    {siteInfo?.compStatePubYn === 'Y' && (
      <div className="w-24 h-12 px-4 inline-flex justify-center items-center">
        <div className="flex-1 text-center justify-center text-zinc-400 text-xs font-normal font-['Noto_Sans_KR'] leading-none">평균시청율</div>
      </div>
    )}
    <div className="w-24 h-12 px-4 inline-flex justify-center items-center">
      <div className="flex-1 text-center justify-center text-zinc-400 text-xs font-normal font-['Noto_Sans_KR'] leading-none">참가여부</div>
    </div>
  </div>
));

// ─── 데스크탑 행 컴포넌트 ─────────────────────────────────────────────────
const DesktopRow = memo(({ item, index, total, siteInfo, onEventClick }) => (
  <div className={`self-stretch p-4 inline-flex justify-start items-center ${index < total - 1 ? 'border-b border-zinc-200 border-solid' : ''}`}>
    <div className="flex-1 inline-flex flex-col justify-center items-start gap-2">
      <div className="flex justify-start items-center gap-x-2">
        {item.serviceTypes && (
          <div className="size- inline-flex justify-start items-center gap-1">
            {item.serviceTypes.split(',').map((serviceType, idx) => (
              <div key={idx}>
                {serviceType.trim() === '라이브' && (
                  <div className="size- min-w-8 px-1 bg-white rounded outline outline-1 outline-offset-[-1px] outline-[#F43F5E] flex justify-center items-center text-[12px] leading-4 font-normal ">
                    <div className="text-center justify-center text-[#F43F5E] text-[12px] font-normal leading-4">LIVE</div>
                  </div>
                )}
                {serviceType.trim() === '온디맨드' && (
                  <div className="size- min-w-8 px-1 bg-white rounded outline outline-1 outline-offset-[-1px] outline-indigo-500 flex justify-center items-center">
                    <div className="text-center justify-center text-indigo-500 text-xs font-normal leading-4">On Demand</div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
        {siteInfo?.compStatePubYn === 'Y' && (
          <div className="justify-start text-zinc-500 text-sm font-normal font-['Noto_Sans_KR'] leading-none">
            {item.eventStatus}
          </div>
        )}
      </div>
      <div className="self-stretch inline-flex justify-start items-center">
        <div
          className="flex-1 justify-center text-zinc-700 text-lg font-bold font-['Noto_Sans_CJK_KR'] leading-6 cursor-pointer hover:text-indigo-600 transition-colors"
          onClick={() => onEventClick(item)}
        >
          {item.eventName}
        </div>
      </div>
      <div className="self-stretch justify-start text-zinc-500 text-sm font-normal font-['Noto_Sans_KR'] leading-5">
        {moment(item.startDate).format('MM.DD HH:mm')} ~ {moment(item.endDate).format('MM.DD HH:mm')} KST
        {item.durationText}
      </div>
    </div>

    <div className="w-24 p-4 flex justify-center items-center">
      <div
        className="justify-center text-zinc-500 text-base font-normal font-['Noto_Sans_KR'] leading-normal underline cursor-pointer"
        onClick={() => onEventClick(item)}
      >
        {item.participatedSessionCount}/{item.totalSessionCount}
      </div>
    </div>
    <div className="w-28 flex justify-center items-center">
      <div className="justify-center text-zinc-500 text-base font-normal font-['Noto_Sans_KR'] leading-normal">
        {item.firstAccessTime ? moment(item.firstAccessTime).format('MM.DD HH:mm') : '-'}
      </div>
    </div>
    <div className="w-28 p-4 flex justify-center items-center">
      <div className="justify-center text-base font-normal font-['Noto_Sans_KR'] leading-normal text-zinc-500">
        {(item.totalPlayTime || '-')}
      </div>
    </div>
    {siteInfo?.compStatePubYn === 'Y' && (
      <div className="w-24 p-4 flex justify-center items-center">
        <div className="justify-center text-zinc-500 text-base font-normal font-['Noto_Sans_KR'] leading-normal">
          {item.averageWatchRate ? `${Math.round(item.averageWatchRate)} %` : '-'}
        </div>
      </div>
    )}
    <div className="w-24 p-4 flex flex-col justify-center items-center gap-2">
      <div className={`text-center text-base font-medium font-['Noto_Sans_KR'] leading-tight ${
        item?.firstAccessTime ? 'text-zinc-700' : 'text-zinc-400'
      }`}>
        {item?.firstAccessTime ? '참가' : '미참가'}
      </div>
    </div>
  </div>
));

// ─── 모바일 행 컴포넌트 ───────────────────────────────────────────────────
const MobileRow = memo(({ item, onEventClick }) => (
  <div className="self-stretch py-4 inline-flex flex-col justify-center items-start gap-6 border-b border-zinc-200 border-solid">
    <div className="self-stretch inline-flex justify-start items-start gap-2.5">
      <div className="flex-1 inline-flex flex-col justify-center items-start gap-1">
        <div className="size- inline-flex justify-start items-center gap-2">
          {item.serviceTypes && (
            <div className="size- inline-flex justify-start items-center gap-1">
              {item.serviceTypes.split(',').map((serviceType, idx) => (
                <div key={idx}>
                  {serviceType.trim() === '라이브' && (
                    <div className="size- min-w-8 h-4 px-1 bg-white rounded-sm outline outline-1 outline-offset-[-1px] outline-rose-500 flex justify-center items-center">
                      <div className="text-center justify-center text-rose-500 text-xs font-normal font-['Noto_Sans_KR'] leading-none">LIVE</div>
                    </div>
                  )}
                  {serviceType.trim() === '온디맨드' && (
                    <div className="size- min-w-8 h-4 px-1 bg-white rounded-sm outline outline-1 outline-offset-[-1px] outline-indigo-500 flex justify-center items-center">
                      <div className="text-center justify-center text-indigo-500 text-xs font-normal font-['Noto_Sans_KR'] leading-none">On Demand</div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
          <div className="justify-start text-zinc-500 text-sm font-normal font-['Noto_Sans_KR'] leading-none">
            {item.eventStatus || '진행완료'}
          </div>
        </div>

        <div className="self-stretch inline-flex justify-start items-start gap-2">
          <div
            className="flex-1 justify-center text-zinc-700 text-lg font-bold font-['Noto_Sans_CJK_KR'] leading-normal cursor-pointer hover:text-indigo-600 transition-colors"
            onClick={() => onEventClick(item)}
          >
            {item.eventName}
          </div>
        </div>

        <div className="self-stretch inline-flex justify-start items-center gap-1">
          <div className="justify-start text-zinc-500 text-sm font-normal font-['Noto_Sans_KR'] leading-tight">
            {moment(item.startDate).format('MM.DD HH:mm')} ~ {moment(item.endDate).format('MM.DD HH:mm')} KST
          </div>
          <div className="justify-start text-zinc-500 text-sm font-normal font-['Noto_Sans_KR'] leading-tight">
            {item.durationText}
          </div>
        </div>
      </div>
    </div>

    <div className="w-full inline-flex justify-between items-center">
      <div className="w-full flex justify-between items-center">
        <div className="size- flex justify-center items-center gap-2.5">
          <div className="justify-start text-zinc-400 text-base font-normal font-['Noto_Sans_KR'] leading-normal">참가세션</div>
          <div
            className="justify-start text-zinc-500 text-base font-normal font-['Noto_Sans_KR'] underline leading-normal cursor-pointer hover:text-indigo-600 transition-colors"
            onClick={() => onEventClick(item)}
          >
            {item.participatedSessionCount}/{item.totalSessionCount}
          </div>
        </div>
      </div>
    </div>
  </div>
));

// ─── 기본 내보내기 ─────────────────────────────────────────────────────────
export default (props) => {
  const { match } = props;
  const eventIdx = match?.params.eventIdx;

  return (
    <Fragment>
      <Layout>
        <Wrapper>
          <EventForm eventIdx={eventIdx} />
        </Wrapper>
      </Layout>
    </Fragment>
  );
};

// ─── 메인 폼 컴포넌트 ─────────────────────────────────────────────────────
const EventForm = () => {
  const { iam } = useContext(AppContext);
  const { siteInfo } = useStore();
  const [list, setList] = useState([]);
  const [paging, setPaging] = useState(null);
  const [dataLoadingShow, setDataLoadingShow] = useState(false);
  const [isMobile, setIsMobile] = useState(() => window.matchMedia('(max-width: 767px)').matches);

  // 모달 상태 관리
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  // 화면 크기 감지 (matchMedia: 경계값 교차 시에만 이벤트 발생)
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  const handleEventClick = useCallback((eventData) => {
    setSelectedEvent(eventData);
    setModalOpen(true);
  }, []);

  const handleModalClose = useCallback(() => {
    setModalOpen(false);
    setSelectedEvent(null);
  }, []);

  const onPageChange = useCallback((page) => {
    loadList(page);
  }, []);

  const loadList = (page) => {
    const req = {
      path: "/v1/client/mypage/join/symposium/list",
      data: {
        siteIdx: iam.siteIdx,
        passCode: iam.passCode,
        page: page ?? 1,
        numPerPage: 10,
        pagePerBlock: 5,
      },
    };

    _API.post(req).then((res) => {
      let { data, paging } = res.data;

      // 렌더 시점이 아닌 데이터 로드 시점에 durationText 계산
      data = data.map((item) => ({
        ...item,
        durationText: computeDurationText(item.startDate, item.endDate),
      }));

      setList(data);
      const pagingItems = [];
      if (paging) {
        for (let i = paging.startPageNo; i <= paging.endPageNo; i++) {
          pagingItems.push(i);
        }
      }
      paging.pagingItems = pagingItems;
      setPaging(paging);
    });
  };

  const loadPdf = async (item) => {
    setDataLoadingShow(true);

    let division = 0;
    if (item.eventIdx == 709) {
      division = 1;
    } else {
      division = 2;
    }

    if (item.dataUrl == null) {
      const req = {
        path: "http://localhost:3030/xlsx",
        data: {
          name: iam.name,
          companyName: iam.companyName,
          div: division,
          sessionIdx: item.sessionIdx,
          preregIdx: iam.preregIdx,
        },
        ondemand: true,
      };

      await _API.post(req).then((res) => {
        const { result } = res.data;
        loadList(1);
        setDataLoadingShow(false);
        window.open('about:blank').location.href = result;
      });
    } else {
      loadList(1);
      setDataLoadingShow(false);
      window.open('about:blank').location.href = item.dataUrl;
    }
  };

  useEffect(() => {
    loadList(1);
  }, [iam?.siteIdx]);

  const emptyMessage = (
    <div className="self-stretch p-4 flex justify-center items-center">
      <div className="text-center text-zinc-400 text-base font-normal font-['Noto_Sans_KR']">참가내역 이벤트가 없습니다.</div>
    </div>
  );

  return (
    <Fragment>
      <div className="mypage_header_bnr">
        <h2>마이페이지</h2>
      </div>
      <div className="mypage_tab_menu_wrapper">
        <div className="mypage_tab_menu">
          <div className="mypage_tab">
            <Swiper
              spaceBetween={0}
              slidesPerView={"auto"}
              className="mypage_list"
            >
              <SwiperSlide key="mypage">
                <Link to="/mypage" className="link">개인정보</Link>
              </SwiperSlide>
              {(siteInfo?.idx == '51' || siteInfo?.idx == '113' || siteInfo?.idx == '1') && (
                <SwiperSlide key="symposium" className="active">
                  <Link to="/join/symposium" className="link">참가내역</Link>
                </SwiperSlide>
              )}
            </Swiper>
          </div>
        </div>
      </div>

      <div className="content_inner">
        <div className="wid_1180">
          <div className="w-full mb-5 self-stretch p-5 bg-neutral-50 rounded-md inline-flex flex-col justify-start items-start gap-3">
            <div className="self-stretch justify-start text-zinc-500 text-base font-normal font-['Noto_Sans_KR'] leading-normal">
              <div>참가하신 심포지엄의 시청시간 및 시청률은 익일 오전 10시 이후에 확인이 가능합니다. 참가내역은 라이브 심포지엄에 한하여 제공됩니다.</div>
            </div>
          </div>
          <div className="content_inner_wrap">
            {!isMobile ? (
              /* 데스크탑 테이블 뷰 */
              <div className="w-full self-stretch bg-white rounded-md outline outline-1 outline-offset-[-1px] outline-zinc-200 inline-flex flex-col justify-start items-start">
                <DesktopTableHeader siteInfo={siteInfo} />
                <div className="self-stretch flex flex-col justify-center items-start">
                  {list != null && list.length > 0 ? (
                    list.map((item, i) => (
                      <DesktopRow
                        key={i}
                        item={item}
                        index={i}
                        total={list.length}
                        siteInfo={siteInfo}
                        onEventClick={handleEventClick}
                      />
                    ))
                  ) : emptyMessage}
                </div>
              </div>
            ) : (
              /* 모바일 카드 뷰 */
              <div className="w-full self-stretch bg-white inline-flex flex-col justify-start items-start border-t border-zinc-200 border-solid">
                {list != null && list.length > 0 ? (
                  list.map((item, i) => (
                    <MobileRow
                      key={i}
                      item={item}
                      onEventClick={handleEventClick}
                    />
                  ))
                ) : emptyMessage}
              </div>
            )}

            <Paging paging={paging} loadList={loadList} pageCallback={onPageChange} />
          </div>
        </div>
      </div>

      {/* 이벤트 상세 모달 */}
      <BaseModal
        open={modalOpen}
        onClose={handleModalClose}
        title="세션 참가정보"
      >
        <EventDetailContent
          eventData={selectedEvent}
          onDownloadCertificate={loadPdf}
        />
      </BaseModal>

      {/* PDF 생성 로딩 모달 */}
      <BaseModal
        open={dataLoadingShow}
        onClose={() => {}}
        title="참가증명서 생성 중"
        size="sm"
      >
        <div className="text-center py-8">
          <div className="mb-6">
            <img
              src="https://cdn.onoffevent.com/common/hub_data_loading.gif"
              alt="로딩 중"
              className="w-20 h-20 mx-auto"
            />
          </div>
          <p className="text-lg font-medium text-zinc-700 mb-2">PDF 생성 중...</p>
          <p className="text-sm text-zinc-500">잠시만 기다려주세요.</p>
        </div>
      </BaseModal>
    </Fragment>
  );
};
